import useGetUserAgentStats from '../../hooks/useGetUserAgentStats.hook';
import { useEffect } from 'react';
import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import UserAgentPieChart from './components/useragent-pie-chart';
import { COLOR_MAP_BROWSER, COLOR_MAP_DEVICE, COLOR_MAP_OS } from './utils/color-map';
import { useAnalytics } from '../../hooks/useAnalytics.hook';
import _ from 'lodash';

type UserAgentItem = { name: string; count: number };

const UserAgentMetrics = () => {
  const { state } = usePlayground();
  const { dateFilter, filters, updateFilter } = useAnalytics();
  const getUserAgentStats = useGetUserAgentStats();

  useEffect(() => {
    if (!state.payload?._id) return;

    getUserAgentStats.mutate({
      link_in_bio_id: state.payload._id,
      start_date: dateFilter.start,
      end_date: dateFilter.end,
      ...filters,
    });
  }, [state.payload?._id, dateFilter, filters]);

  if (!getUserAgentStats.data) return null;

  return (
    <div className="flex flex-col md:flex-row items-center justify-center border border-secondary bg-dark rounded-2xl p-4 my-6">
      <UserAgentPieChart
        label="Devices"
        chartData={
          filters.device
            ? getUserAgentStats.data.data.device
                .filter((item: UserAgentItem) => item.name === filters.device)
                .map((item: UserAgentItem) => ({
                  ...item,
                  name: _.capitalize(item.name),
                }))
            : getUserAgentStats.data.data.device.map((item: UserAgentItem) => ({
                ...item,
                name: _.capitalize(item.name),
              }))
        }
        colorMap={COLOR_MAP_DEVICE}
        onLegendClick={(item) => {
          if (filters.device === item.value) return;
          updateFilter('device', item.value === 'Other' ? 'Other' : item.value.toLowerCase());
        }}
      />
      <div className="hidden md:block w-px bg-secondary self-stretch" />
      <div className="block md:hidden w-full h-[1px] bg-secondary my-6" />
      <UserAgentPieChart
        label="Browsers"
        chartData={
          filters.browser
            ? getUserAgentStats.data.data.browser.filter((item: UserAgentItem) => item.name === filters.browser)
            : getUserAgentStats.data.data.browser
        }
        colorMap={COLOR_MAP_BROWSER}
        onLegendClick={(item) => {
          if (filters.browser === item.value) return;
          updateFilter('browser', item.value);
        }}
      />
      <div className="hidden md:block w-px bg-secondary self-stretch" />
      <div className="block md:hidden w-full h-[1px] bg-secondary my-6" />
      <UserAgentPieChart
        label="Operating Systems"
        chartData={
          filters.os
            ? getUserAgentStats.data.data.os.filter((item: UserAgentItem) => item.name === filters.os)
            : getUserAgentStats.data.data.os
        }
        colorMap={COLOR_MAP_OS}
        onLegendClick={(item) => {
          if (filters.os === item.value) return;
          updateFilter('os', item.value);
        }}
      />
    </div>
  );
};

export default UserAgentMetrics;
